<template>
  <div>
    <InningTournamentModal />
    <TournamentEditGameModal
      :tournamentData="tournamentData"
      :association_id="association_id"
    />
    <div v-if="showLoader === 1" class="card-event mt-3">
      <content-placeholders :rounded="true">
        <content-placeholders-img />
        <content-placeholders-heading />
      </content-placeholders>

      <br />

      <content-placeholders :rounded="true">
        <content-placeholders-img />
        <content-placeholders-heading />
      </content-placeholders>
    </div>
    <div
      class="no-event-wrap h-100"
      v-else-if="gameList.length === 0 && showLoader === 0"
    >
      <img src="../../assets/Svg/no-data.svg" alt />
      <p class="header">No division games found.</p>
      <p class="info">There are no division games to display.</p>
    </div>
    <div
      v-if="gameList.length > 0 && showLoader === 0"
      class="live-league-wrap"
    >
      <!-- Group games by date -->
      <div v-for="(dateGroup, date) in groupedGames" :key="date">
        <h2 class="date-heading">{{ formatDate(date) }}</h2>
        <div
          v-for="(schedule, index) in dateGroup"
          :key="index"
          data-dismiss="modal"
        >
          <div
            class="row no-gutters schedule-info flex-column flex-md-row justify-content-start single-event-side-game"
            @click="callBoxViewModal(schedule)"
          >
            <div class="col-12 col-lg-3 col-xl-4 pr-lg-1 left-side-portion">
              <div class="start-time">{{ schedule.start_time }}</div>
              <div>{{ formatDate(schedule.start_date) }}</div>
              <div class="content" v-if="schedule.umpire">
                Umpire: {{ schedule.umpire?.name }}
              </div>
            </div>
            <div
              class="col-12 col-lg-9 col-xl-8 mt-3 mt-lg-0 d-flex align-items-center flex-wrap flex-grow-1 flex-column flex-md-row"
            >
              <div class="row no-gutters w-100 align-items-center">
                <div
                  class="col-12 col-lg-4 d-flex flex-row flex-wrap justify-content-center"
                >
                  <div v-if="schedule.game_scores?.length != 0">
                    <div
                      class="opponent-tag"
                      v-if="
                        schedule.game_scores?.some(
                          (team) => team.team_type === 1
                        )
                      "
                    >
                      <h6
                        :class="{
                          'winner-text':
                            schedule.status === 2 &&
                            calculateGameScores(schedule).visitRuns >
                              calculateGameScores(schedule).homeRuns,
                          'loser-text':
                            schedule.status === 2 &&
                            calculateGameScores(schedule).visitRuns <
                              calculateGameScores(schedule).homeRuns,
                        }"
                      >
                        #{{
                          schedule.game_scores?.find(
                            (team) => team.team_type === 1
                          )?.teams?.team_sr_no
                        }}:
                        {{
                          schedule.game_scores?.find(
                            (team) => team.team_type === 1
                          )?.team?.team_name
                        }}
                      </h6>
                      <div class="custom-avatar" 
                        v-if="schedule.game_scores?.find(team => team.team_type === 1)?.team?.team_avatar == null"
                        :style="{ backgroundColor: getRandomColor() }">
                        {{ getInitials(schedule?.game_scores?.find(team => team?.team_type === 1)?.team?.team_name) }}
                      </div>
                      <div class="team-image" v-else>
                        <div class="users-notification" v-if="imgLoader == 1">
                          <img src="../../assets/loader.gif" alt="" />
                        </div>
                        <img
                          @load="onImageLoad"
                          v-if="
                            schedule.game_scores?.find(
                              (team) => team?.team_type === 1
                            )?.team?.team_avatar == null
                          "
                          :src="team_image"
                          alt=""
                        />
                        <img
                          @load="onImageLoad"
                          v-if="
                            schedule.game_scores?.find(
                              (team) => team.team_type === 1
                            )?.team?.team_avatar != null
                          "
                          :src="
                            url +
                              schedule.game_scores?.find(
                                (team) => team.team_type === 1
                              )?.team?.team_avatar
                          "
                          alt=""
                        />
                      </div>
                      <p
                        class="score-text"
                        :class="{
                          'loser-text':
                            schedule.status === 2 &&
                            calculateGameScores(schedule).visitRuns <
                              calculateGameScores(schedule).homeRuns,
                          'winner-text':
                            schedule.status === 2 &&
                            calculateGameScores(schedule).visitRuns >
                              calculateGameScores(schedule).homeRuns
                        }"
                        v-if="
                          calculateGameScores(schedule).homeRuns != 0 ||
                            calculateGameScores(schedule).visitRuns != 0
                        "
                      >
                        {{ calculateGameScores(schedule).visitRuns }}
                      </p>
                      <img
                        :src="arrow_left"
                        class="arrow-image"
                        alt="arrow-left"
                        v-if="
                          schedule.status === 1 &&
                            schedule.game_scores &&
                            schedule.game_scores?.find(
                              (team) =>
                                team.team_type == 1 && team.batting_flag == 1
                            )
                        "
                      />
                      <img
                        :src="cup"
                        alt="cup"
                        v-if="
                          schedule.status === 2 &&
                            calculateGameScores(schedule).visitRuns >
                              calculateGameScores(schedule).homeRuns
                        "
                      />
                    </div>
                  </div>
                  <div class="opponent-data" v-else>
                    <h6>
                      #{{ schedule.team_one?.team_sr_no }}:
                      {{ schedule.team_one?.team_data?.team_name }}
                    </h6>
                    <div class="custom-avatar" 
                      v-if="schedule.team_one?.team_data?.team_avatar == null"
                      :style="{ backgroundColor: getRandomColor() }">
                      {{ getInitials(schedule.team_one?.team_data?.team_name) }}
                    </div>
                    <div class="team-image" v-else>
                      <div class="users-notification" v-if="imgLoader == 1">
                        <img src="../../assets/loader.gif" alt="" />
                      </div>
                      <img
                        @load="onImageLoad"
                        v-if="schedule.team_one?.team_data?.team_avatar == null"
                        :src="team_image"
                        alt=""
                      />
                      <img
                        @load="onImageLoad"
                        v-if="schedule.team_one?.team_data?.team_avatar != null"
                        :src="url + schedule.team_one?.team_data?.team_avatar"
                        alt=""
                      />
                    </div>
                    <span>-</span>
                  </div>
                </div>

                <div class="col-12 col-lg-3 px-lg-1 center-content">
                  <span>{{ schedule?.field?.field_name }}</span>
                  <div
                    class="begin-btn"
                    v-if="schedule.game_scores.length == 0"
                  >
                    Yet to Begin
                  </div>
                  <div
                    class="begin-btn inning-btn"
                    v-if="
                      schedule.game_scores.length != 0 &&
                        schedule.status === 1 &&
                        schedule.game_delayed == 0
                    "
                  >
                    Inning:
                    {{ schedule.game_scores[0].end_inning_flag }}
                  </div>
                  <div
                    class="begin-btn final-btn"
                    v-if="
                      schedule.game_scores.length != 0 && schedule.status === 2
                    "
                  >
                    Final
                  </div>
                  <div
                    class="begin-btn delayed-btn"
                    v-if="
                      schedule.game_scores.length != 0 &&
                        schedule.status === 1 &&
                        schedule.game_delayed == 1
                    "
                  >
                    Delayed
                  </div>
                  <span
                    style="
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        display: -webkit-box;
                                        -webkit-line-clamp: 1;
                                        -webkit-box-orient: vertical;
                                        word-break: break-all;"
                    >{{ schedule.game_name }}
                  </span>
                </div>

                <div
                  class="col-12 col-lg-4 d-flex flex-row flex-wrap justify-content-center right-section-popup"
                >
                  <div v-if="schedule.game_scores?.length != 0">
                    <div
                      class="opponent-tag"
                      v-if="
                        schedule.game_scores?.some(
                          (team) => team.team_type === 2
                        )
                      "
                    >
                      <img
                        :src="arrow_left"
                        class="arrow-image"
                        alt="arrow-left"
                        v-if="
                          schedule.status === 1 &&
                            schedule.game_scores &&
                            schedule.game_scores?.find(
                              (team) =>
                                team.team_type == 2 && team.batting_flag == 1
                            )
                        "
                      />
                      <img
                        :src="cup"
                        alt="cup"
                        v-if="
                          schedule.status === 2 &&
                            calculateGameScores(schedule).homeRuns >
                              calculateGameScores(schedule).visitRuns
                        "
                      />
                      <p
                        class="score-text win-data-two flex-row align-items-center"
                        :class="{
                          'loser-text':
                            schedule.status === 2 &&
                            calculateGameScores(schedule).homeRuns <
                              calculateGameScores(schedule).visitRuns,
                          'winner-text':
                            schedule.status === 2 &&
                            calculateGameScores(schedule).homeRuns >
                              calculateGameScores(schedule).visitRuns
                        }"
                        v-if="
                          calculateGameScores(schedule).homeRuns != 0 ||
                            calculateGameScores(schedule).visitRuns != 0
                        "
                        style="gap: 5px"
                      >
                        {{ calculateGameScores(schedule).homeRuns }}
                      </p>
                      <div class="custom-avatar" 
                        v-if="schedule.game_scores?.find(team => team.team_type === 2)?.team?.team_avatar == null"
                        :style="{ backgroundColor: getRandomColor() }">
                        {{ getInitials(schedule.game_scores?.find(team => team?.team_type === 2)?.team?.team_name) }}
                      </div>
                      <div class="team-image" v-else>
                        <div class="users-notification" v-if="imgLoader == 1">
                          <img src="../../assets/loader.gif" alt="" />
                        </div>
                        <img
                          @load="onImageLoad"
                          v-if="
                            schedule.game_scores?.find(
                              (team) => team.team_type === 2
                            )?.team?.team_avatar == null
                          "
                          :src="team_image"
                          alt=""
                        />
                        <img
                          @load="onImageLoad"
                          v-if="
                            schedule.game_scores?.find(
                              (team) => team.team_type === 2
                            )?.team?.team_avatar != null
                          "
                          :src="
                            url +
                              schedule.game_scores?.find(
                                (team) => team.team_type === 2
                              )?.team?.team_avatar
                          "
                          alt=""
                        />
                      </div>
                      <h6
                        :class="{
                          'winner-text':
                            schedule.status === 2 &&
                            calculateGameScores(schedule).homeRuns >
                              calculateGameScores(schedule).visitRuns,
                          'loser-text':
                            schedule.status === 2 &&
                            calculateGameScores(schedule).homeRuns <
                              calculateGameScores(schedule).visitRuns,
                        }"
                      >
                        #{{
                          schedule.game_scores?.find(
                            (team) => team.team_type === 2
                          )?.teams?.team_sr_no
                        }}:
                        {{
                          schedule.game_scores?.find(
                            (team) => team?.team_type === 2
                          )?.team?.team_name
                        }}
                      </h6>
                    </div>
                  </div>
                  <div class="opponent-data" v-else>
                    <span>-</span>
                    <div class="custom-avatar" 
                      v-if="schedule.team_two?.team_data?.team_avatar == null"
                      :style="{ backgroundColor: getRandomColor() }">
                      {{ getInitials(schedule.team_two?.team_data?.team_name) }}
                    </div>
                    <div class="team-image" v-else>
                      <div class="users-notification" v-if="imgLoader == 1">
                        <img src="../../assets/loader.gif" alt="" />
                      </div>
                      <img
                        @load="onImageLoad"
                        v-if="schedule.team_two?.team_data?.team_avatar == null"
                        :src="team_image"
                        alt=""
                      />
                      <img
                        @load="onImageLoad"
                        v-if="schedule.team_two?.team_data?.team_avatar != null"
                        :src="url + schedule.team_two?.team_data?.team_avatar"
                        alt=""
                      />
                    </div>
                    <h6>
                      #{{ schedule?.team_two?.team_sr_no }}:
                      {{ schedule.team_two?.team_data?.team_name }}
                    </h6>
                  </div>
                </div>
                <div
                  @click.stop="handleActionClick(schedule)"
                  class="col-12 col-lg-1 pl-lg-1 center-content d-flex justify-content-end"
                >
                  <TournamentEllipsis
                    v-if="currentIsAdmin == '1' || schedule.umpire_id == UserId"
                    :clickedGame="schedule"
                    :currentIsAdmin="currentIsAdmin"
                    :currentIsUmpire="currentIsUmpire"
                    :association_id="association_id"
                    ref="ellipsisDropdown"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TournamentEllipsis from "../Tournaments/Modals/TournamentTeamActionModal.vue";
import TournamentEditGameModal from "../Tournaments/Modals/TournamentEditGameModal.vue";
import InningTournamentModal from "../Tournaments/InningTournamentModal.vue";

export default {
  name: "AssociationGameListing",
  components: {
    TournamentEllipsis,
    TournamentEditGameModal,
    InningTournamentModal,
  },
  data() {
    return {
      url: this.$groupAvatarStorageURL,
      imgLoader: 1,
      gameList: [], // Dummy game list
      singleGame: {},
      showLoader: 1,
      page: 1,
      lastPage: 1,
      totalGames: null,
      arrow_left: require("../../assets/Svg/arrow-left.svg"),
      cup: require("../../assets/Svg/cup.svg"),
      team_image: require("../../assets/Svg/people.svg"),
      tournament_guid: "",
      allGamesCompleted: false,
      clickedGame: [],
      UserId: localStorage.getItem("userId"),
    };
  },
  computed: {
    // Group games by date
    groupedGames() {
      const groups = {};
      this.gameList.forEach((game) => {
        const date = game.start_date; // Use just the date part as key
        if (!groups[date]) {
          groups[date] = [];
        }
        groups[date].push(game);
      });

      // Sort the games within each date group by start_time
      Object.keys(groups).forEach((key) => {
        groups[key].sort((a, b) => {
          const dateA = new Date(`2000-01-01 ${a.start_time}`);
          const dateB = new Date(`2000-01-01 ${b.start_time}`);
          return dateA - dateB;
        });
      });

      // Sort date groups in ascending order
      const sortedGrouped = {};
      Object.keys(groups)
        .sort((a, b) => new Date(a) - new Date(b))
        .forEach((key) => {
          sortedGrouped[key] = groups[key];
        });

      return sortedGrouped;
    },
  },
  props: {
    tournamentData: {
      type: Array,
    },
    currentIsUmpire: {
      type: String,
    },
    currentIsAdmin: {
      type: String,
    },
    association_id: {
      type: Number,
    },
  },
  methods: {
    getInitials(name) {
      return name ? name.charAt(0).toUpperCase() : "?";
    },
    getRandomColor() {
      const colors = [
        "#FCE4EC",
        "#E3F2FD",
        "#F1F8E9",
        "#FFF8E1",
        "#EDE7F6",
        "#FFEBEE",
        "#F9FBE7",
        "#FFF3E0",
        "#ECEFF1",
        "#FFECB3",
      ];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    handleActionClick(data) {
      this.clickedGame = data;
    },
    callBoxViewModal(score) {
      console.log(score);
      if (score.game_scores.length != 0) {
        this.$root.$emit("openBoxViewScoresModal", score);
        this.$root.$emit("openBoxViewInningModal", score);
      }
    },
    // isLastGame(date, index) {
    //     // Check if this is the last game in both the date group and the entire list
    //     const dateGroup = this.groupedGames[date];
    //     return index === dateGroup.length - 1 &&
    //         date === Object.keys(this.groupedGames)[Object.keys(this.groupedGames).length - 1];
    // },
    formatDate(dateString) {
      const date = new Date(dateString + "T00:00:00"); // Prevents timezone shift

      if (isNaN(date)) {
        return "";
      }

      const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const weekday = weekdays[date.getDay()];
      const month = months[date.getMonth()];
      const day = date.getDate();
      const year = date.getFullYear();

      return `${weekday} ${month} ${day}, ${year}`;
    },
    onImageLoad() {
      this.imgLoader = 0;
    },
    async getGames() {
      this.showLoader = 1;

      var formData = new FormData();
      formData.append(
        "tournament_guid",
        this.tournament_guid
          ? this.tournament_guid
          : this.tournamentData[0].guid
      );
      await axios
        .post(
          process.env.VUE_APP_API_URL + "tournaments/getTournamentGames",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          const allGames = response.data.data;
            // ✅ Filter games with game_type === 1
            const filteredGames = allGames.filter((game) => game.game_type === 1);
            this.gameList = this.gameList.concat(filteredGames);

            // ✅ Check if ALL filtered games are completed
            this.allGamesCompleted =
              filteredGames.length > 0 && filteredGames.every((game) => game.status == 2);

            this.lastPage = response.data.data.last_page;
            this.totalGames = response.data.data.total;

            this.$root.$emit("allGamesCompleted", this.allGamesCompleted);
            this.$emit("games-loaded", this.gameList);
            this.showLoader = 0;
        });
    },
    calculateGameScores(gameItem) {
      if (!gameItem.game_scores || gameItem.game_scores.length === 0) {
        return { homeRuns: 0, visitRuns: 0 };
      }

      let homeRuns = 0;
      let visitRuns = 0;

      // Process each team's scores
      gameItem.game_scores.forEach((gameS) => {
        if (gameS.team_type === 1) {
          // Visiting team
          gameS.game_innings.forEach((inning) => {
            if (inning.inning_type === 2 && inning.score !== null) {
              // Only count runs (inning_type 2)
              visitRuns += parseInt(inning.score);
            }
          });
        } else if (gameS.team_type === 2) {
          // Home team
          gameS.game_innings.forEach((inning) => {
            if (inning.inning_type === 2 && inning.score !== null) {
              // Only count runs (inning_type 2)
              homeRuns += parseInt(inning.score);
            }
          });
        }
      });

      return { homeRuns, visitRuns };
    },
    openParkGoogleMap(item) {
      let urlSuffix;
      if (item["lat"] && item["lng"]) {
        const strlatLng = item["lat"] + "," + item["lng"];
        urlSuffix = strlatLng;
      } else {
        urlSuffix = encodeURIComponent(
          item["address"] + ", " + item["city"] + ", " + item["zipCode"]
        );
      }
      window.open(
        "https://www.google.com/maps/search/?api=1&query=" + urlSuffix,
        "_blank"
      );
    },
  },
  mounted() {
    const storedTournamentID = localStorage.getItem("tournamentID");
    if (storedTournamentID) {
      this.tournament_guid = storedTournamentID;
    }
    this.getGames();

    this.$root.$on("RefreshTournamentGames", () => {
      this.gameList = [];
      this.getGames();
    });

    this.$root.$on("changeDivision", (tournamentID) => {
      this.allGamesCompleted = false;
      this.tournament_guid = tournamentID;
      localStorage.setItem("tournamentID", tournamentID); // Save to localStorage
      this.gameList = [];
      this.getGames();
    });
  },
};
</script>
